// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";


const http = new AxiosAdapter();



export const getEmployesService = async() => {
   
    try {
        
        return await http.get<any>('/v1/employes'); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getEmployesService ',error);

    }
}


export const getEmployesDataCreateService = async() => {
   
    try {
        
        return await http.get<any>('/v1/employes/data-create-form-inputs'); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getEmployesService ',error);

    }
}


export const getEmployesByPaginateService = async(page:number) => {
   
    try {

        return await http.get<any>(`/v1/employes?page=${page}&take=10`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getEmployesByPaginateService ',error)
    }
}



export const saveEmployeeService = async(employee:object, setPercentajeCCompany:any) => {
   
    try {
        
        return await http.post<any>('/v1/employes', employee, setPercentajeCCompany); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('saveEmployeeService ',error);
    }
}



export const desactiveEmployeService = async(employeId: string) => {
   
    try {

        return await http.delete<any>(`/v1/employes/${employeId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('desactiveEmployeService ',error);

    }
}




export const activeEmployeService = async(employeId: string) => {
   
    try {

        return await http.patch<any>(`/v1/employes/${employeId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('activeEmployeService ',error);

    }
}




export const getEmployeeDetailService = async(employeeId:string) => {
   
    try {

        return await http.get<any>(`/v1/employes/${employeeId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getEmployeeDetailService ',error);

    }
}